// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"2e6910815baf151d","6831":"e614e36cea8a516c","8503":"97a9062f28c21b8a","9683":"0ba69892d1792a2a"}[chunkId] + ".js";
};